import React, { useState, useEffect } from "react";
import axios from "../utils/axios";
import "./styles/SiteViewer.css";
import logo from "./assets/logo.png"; // update path if needed

export default function SiteViewer() {
  const [masterSites, setMasterSites] = useState([]);
  const [selectedMasterSite, setSelectedMasterSite] = useState("");
  const [sites, setSites] = useState([]);
  const [selectedSite, setSelectedSite] = useState(null);
  const [dummyTds, setDummyTds] = useState(null);
  const [dummyPh, setDummyPh] = useState(null);

  useEffect(() => {
    fetchMasterSites();
  }, []);

  const fetchMasterSites = async () => {
    try {
      const res = await axios.get("/mastersites");
      setMasterSites(res.data);
    } catch (err) {
      console.error("Error fetching master sites", err);
    }
  };

  const fetchSites = async () => {
    try {
      const res = await axios.get("/sites");
      const filteredSites = res.data.filter(
        (site) => site.masterSiteId === selectedMasterSite
      );
      setSites(filteredSites);
    } catch (err) {
      console.error("Error fetching sites", err);
    }
  };

  useEffect(() => {
    if (selectedMasterSite) fetchSites();
  }, [selectedMasterSite]);

  const handleSiteSelect = (site) => {
    setSelectedSite(site);
    setDummyTds(Math.floor(Math.random() * (170 - 130 + 1)) + 130);
    setDummyPh([7, 7.5][Math.floor(Math.random() * 2)]);
  };

  return (
    <div className={`site-viewer-full ${selectedSite ? "fullscreen" : ""}`}>
      {selectedSite ? (
        <>
          <img src={logo} alt="Logo" className="logo" />

          <div className="site-info-row">
            <div className="site-block"><strong>{selectedSite.name}</strong></div>
            <div className="site-block">TDS (ppm): <strong>{dummyTds}</strong></div>
            <div className="site-block">pH: <strong>{dummyPh}</strong></div>
          </div>
        </>
      ) : (
        <div className="dropdown-panel">
          <h2>Select Site to View Details</h2>

          <label>Master Site:</label>
          <select
            value={selectedMasterSite}
            onChange={(e) => {
              setSelectedMasterSite(e.target.value);
              setSelectedSite(null);
            }}
          >
            <option value="">-- Select --</option>
            {masterSites.map((ms) => (
              <option key={ms._id} value={ms._id}>
                {ms.name}
              </option>
            ))}
          </select>

          {sites.length > 0 && (
            <>
              <label>Site:</label>
              <select onChange={(e) => {
                const site = sites.find(s => s._id === e.target.value);
                if (site) handleSiteSelect(site);
              }}>
                <option value="">-- Select --</option>
                {sites.map((site) => (
                  <option key={site._id} value={site._id}>
                    {site.name}
                  </option>
                ))}
              </select>
            </>
          )}
        </div>
      )}
    </div>
  );
}
